import { useEffect, useState } from 'react'
import { requestGame } from './gameLogic'

// The server owns the game date. Recheck at midnight and when a suspended tab returns.
export default function useGameMode() {
  const [mode, setMode] = useState(null)
  const [error, setError] = useState('')
  useEffect(() => {
    let cancelled = false
    let timer
    const refresh = async () => {
      clearTimeout(timer)
      try {
        const data = await requestGame('mode/')
        if (!cancelled) {
          setMode(previous => previous?.mode === data.mode && previous?.date === data.date ? previous : data)
          setError('')
          timer = setTimeout(refresh, Math.min(30000, data.refresh_after_ms + 100))
        }
      } catch (_) {
        if (!cancelled) {
          setError('Could not load today’s game. Please refresh or try again shortly.')
          timer = setTimeout(refresh, 5000)
        }
      }
    }
    const onVisible = () => { if (document.visibilityState === 'visible') refresh() }
    refresh()
    document.addEventListener('visibilitychange', onVisible)
    return () => { cancelled = true; clearTimeout(timer); document.removeEventListener('visibilitychange', onVisible) }
  }, [])
  return { mode, error }
}
